function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "99",
  viewBox: "0 0 12 99",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10 98L2 87.273l8-10.841-8-10.727 8-10.841-8-10.727 8-10.842-8-10.727 8-10.84L2 1",
  stroke: "#fff",
  strokeWidth: "2",
  strokeMiterlimit: "10"
})));